import { render, staticRenderFns } from "./ReportPrivateFeedbackV2.vue?vue&type=template&id=55cade6e&scoped=true&"
import script from "./ReportPrivateFeedbackV2.vue?vue&type=script&lang=js&"
export * from "./ReportPrivateFeedbackV2.vue?vue&type=script&lang=js&"
import style0 from "./ReportPrivateFeedbackV2.vue?vue&type=style&index=0&id=55cade6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cade6e",
  null
  
)

export default component.exports